import * as linkify from "linkifyjs";

const regexp = {
  slug: /^[a-z0-9-]+[0-9a-z-]*$/,
  sku: /^[a-z0-9-_]+[0-9a-z-_]*$/,
};

export const validators = {
  required: (value) => {
    return !!value || "Campo richiesto";
  },
  piva: (value) => {
    if (value) {
      return /^[a-zA-Z]{2}[0-9]{11}$/.test(value) || "Valore non valido";
    }
    return true;
  },
  number: (value) => !isNaN(value) || !value || "Valore numerico richiesto",
  password: (value) => {
    if (value.length <= 8) return "valid.password_length";

    if (!/[%^&*]/.test(value)) return "valid.password_special_chars";

    return true;
  },
  zipcode: (value) => {
    return !value || /^\d{5}$/.test(value) || "Inserire un CAP valido";
  },
  email: (value) =>
    !value || linkify.test(value, "email") || "Inserire un'email valida",
  url: (value) => {
    return !value || linkify.test(value) || "Inserire un link valido";
  },

  sku: (value) =>
    !value ||
    regexp.sku.test(value) ||
    "Sono ammessi solo caratteri minuscoli e trattini",
  positiveInteger(value) {
    value = Number(value);
    return Number.isInteger(value) || "Inserire una quantità valida";
  },
  positiveNumber(value) {
    value = Number(value);
    return (
      (!isNaN(value) && value >= 0) || "Inserire un valore numerico positivo"
    );
  },
};

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide("valid", validators);
});
